
function initialState () {
  return {
    id: '',
    name: '',
    ssn: '',
    bank: '',
    customerId: '',
    submissionType: ''
  }
}

// initial state
const state = initialState()

// actions
const actions = { }

// mutations
const mutations = {
  reset (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  saveUser (state, value) {
    state.id = value.id
    state.name = value.name
    state.ssn = value.ssn
    state.customerId = value.customerId
    state.submissionType = value.submissionType
  },

  saveBank (state, value) {
    state.bank = value
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js